module.exports = __webpack_public_path__ + "static/media/othersIco_Selected.4698bd50.svg";